import { Component } from '@angular/core';

import { TimeRangeService } from '../../services/time-range';

/** Component for showing metadata about the plot data */
@Component({
    selector: 'sci-undo-zoom',
    template: `
        <button mat-icon-button matTooltip="Undo zoom" (click)="undoZoom()">
            <mat-icon svgIcon="undo-zoom"></mat-icon>
        </button>
    `,
    styleUrls: [ './annotations.component.scss' ]
})
export class UndoZoomComponent  {

    constructor( private _timeRangeService: TimeRangeService ) {}

    undoZoom() {
        this._timeRangeService.undoGlobalTimeRangeChange();
    }
}
